export default __webpack_public_path__ + "static/media/higher_icon_phone.5bae5e0a.svg";